<div style="display: flex; align-items: center; padding-left: 30px; padding-right: 30px"
     [style.background-color]="color ? color : '#498257'">

  <img
    src="../../../assets/search_property_house.svg"
    alt=""
    style="height: auto; width: 100px; flex-shrink: 0; align-self: center;">

  <app-ainAddress
    style="flex-grow: 1"
    (AddressList)="submitAddress($event)">
  </app-ainAddress>
</div>
<hr>

